import React from "react";
import NativeLazyImage from "./NativeLazyImage";
import "./../styles/ReviewCard.style.css";
import StarRating from "./StarRating";

export default function ReviewCard({
  name,
  avatar,
  rating,
  review,
  classes = "",
}) {
  return (
    <div
      className={`card review-card rounded-2 bg-white mb-4 border-light border-1 shadow-sm ${classes}`}
    >
      <div className="card-header bg-white">
        <div className="d-flex align-items-center">
          <span
            className="_avatar_wrap me-3"
            style={{
              backgroundImage: `url(
                "/img/fallback/student.png"
              )`,
            }}
          >
            <NativeLazyImage src={avatar} key={avatar} />
          </span>
          <div>
            <h6 className="card-title mb-0">{name}</h6>
            <StarRating rating={rating} />
          </div>
        </div>
      </div>

      <div className="card-body">
        <p
          className="card-text"
          dangerouslySetInnerHTML={{ __html: review }}
        ></p>
      </div>
    </div>
  );
}
